import { module } from 'modujs'

export default class extends module {
    constructor(m) {
        super(m)
    }

    init() {
    }

    onEnter() {
        if (this.$('video')[0].paused) {
            this.$('video')[0].play()
        }
    }

    onLeave() {
        if (!this.$('video')[0].paused) {
            this.$('video')[0].pause()
        }
    }
}